import { useCallback, useState } from 'react';

import ServiceHandler from '../../../../services/service-handler';
import {
    ImgSpcResultsForDerivativeApiDataData,
    ResultsForDerivativeParams,
} from '../../../../models/serice-price-calculator-model';
import {
    API_RESPONSE,
    ApiResponseStatus,
    LoadingStatus,
} from '../../../../contexts/ford-rides-context/ford-rides-context';

export const useImgSpcResultsForDerivative = () => {
    const [
        resultsForDerivativeData,
        setResultsForDerivativeData,
    ] = useState<ImgSpcResultsForDerivativeApiDataData | null>(null);
    const [
        resultsForDerivativeLoading,
        setResultsForDerivativeLoading,
    ] = useState<LoadingStatus>(LoadingStatus.Ideal);
    const [
        resultsForDerivativeApiStatus,
        setResultsForDerivativeApiStatus,
    ] = useState<ApiResponseStatus>(API_RESPONSE.IDLE);

    const fetchImgSpcDataForDerivative = useCallback(
        async (resultsForDerivativeParams: ResultsForDerivativeParams) => {
            setResultsForDerivativeLoading(LoadingStatus.InitialLoad);
            try {
                const resultsForDerivativeApiResponse = await ServiceHandler.ImgSpcServices.resultsForDerivative(
                    {
                        ...resultsForDerivativeParams,
                        isServiceApplicable: '1',
                    }
                );
                if (
                    !resultsForDerivativeApiResponse.result ||
                    resultsForDerivativeApiResponse.message.toLocaleLowerCase() !==
                        'success'
                ) {
                    throw new Error('Failed to fetch results for derivative');
                } else if (
                    resultsForDerivativeApiResponse.data.results.length === 0
                ) {
                    throw new Error('No results found for derivative');
                } else {
                    setResultsForDerivativeData(
                        resultsForDerivativeApiResponse.data
                    );
                    setResultsForDerivativeApiStatus(API_RESPONSE.SUCCESS);
                }
            } catch (error) {
                console.error(
                    'An error occurred while fetching results for derivative:',
                    error
                );
                setResultsForDerivativeApiStatus(API_RESPONSE.FAILURE);
            } finally {
                setResultsForDerivativeLoading(LoadingStatus.LoadingComplete);
            }
        },
        []
    );

    return {
        resultsForDerivativeData,
        resultsForDerivativeLoading,
        resultsForDerivativeApiStatus,
        fetchImgSpcDataForDerivative,
    };
};
